import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  tags: [],
  allTags: [],
  allParentTags: [],
  totalPages: 0,
  totalRecords: 0,
  tag: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_99: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Tags(state, tags) {
    state.tags = tags.items;
    state.totalPages = tags.totalPages;
    state.totalRecords = tags?.totalRecords ?? 0;
  },
  SET_AllTags(state, tags) {
    state.allTags = tags;
  },
  SET_AllParentTags(state, tags) {
    state.allParentTags = tags;
  },
  SET_Tag(state, tag) {
    state.tag = tag;
  },
};
const actions = {
  errorTag({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllTags({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Tags/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllTags', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTag', error);
      });
  },
  getAllParentTags({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Tags/Parents', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllParentTags', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTag', error);
      });
  },
  getTagsWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, title, isParent, isActive },
  ) {
    var url = '/Tags/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    if (isParent != null && isParent != undefined) {
      url += '&IsParent=' + isParent;
    }
    if (isActive != null && isActive != undefined) {
      url += '&IsActive=' + isActive;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_Tags', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTag', error);
      });
  },
  addTag({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Tags', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTag', error);
      });
  },
  getTag({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Tags/ById?tagId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Tag', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTag', error);
      });
  },
  editTag({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Tags/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTag', error);
      });
  },
  deleteTag({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Tags/Remove?tagId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTag', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
